import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { Type } from "class-transformer";
import { ReportTemplateDto } from "@/core/features/report-templates/report-template.dto";

export class ReportSectionDto extends BaseEntityDto {
  title: string;
  sectionTag: string;
  description?: string;
  maximumFiles: number;
  hasTextField: boolean;
  textFieldPlaceholder?: string;

  @Type(() => ReportTemplateDto)
  reportTemplate: ReportTemplateDto;
  reportTemplateId: string;
}
